(function () {
    'use strict';

    angular.module('PWAPoCApp').controller('EndOfOrderAlertModalController', endOfOrderAlertModalController);

    endOfOrderAlertModalController.$inject = ['$scope', '$rootScope', '$windowInstance', 'translateService'];

    function endOfOrderAlertModalController($scope, $rootScope, $windowInstance, translateService) {

        $scope.translate = translateService.translate;

        $scope.confirm = function () {
            $windowInstance.close();
        };
    }
})();
